import {faChevronDown} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import * as React from 'react';
import {FunctionComponent} from 'react';

import {FlatListOrder} from '../../swagger';

export interface FlatsListSorterComponentProps {
    onChange: (v: FlatListOrder) => void;
    currentOrder: FlatListOrder;
}

const sorterOptions = [
    {key: FlatListOrder.Count, label: 'order by count'},
    {key: FlatListOrder.FirstSeen, label: 'order by first seen'},
    {key: FlatListOrder.LastSeen, label: 'order by last seen'},
];

export const FlatsListSorterComponent: FunctionComponent<FlatsListSorterComponentProps> = (p) => (
    <div className="relative">
        <select
            defaultValue={p.currentOrder}
            className="bg-m-gray-2 form-control form-control-sm pr-8 rounded-md text-sm sm:text-base"
            id="set-order" onChange={(e) => p.onChange(e.target.value as FlatListOrder)}>
            {sorterOptions.map((o) => {
                return <option className="text-sm md:text-base" label={o.label} value={o.key} key={o.key}/>;
            })}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
            <FontAwesomeIcon className="fill-current ml-4 text-m-gray-6" icon={faChevronDown}/>
        </div>
    </div>
);
